import {CircleMarker, Polyline, Tooltip} from "react-leaflet";
import {memo} from "react";
import dayjsUTC from "../../shared/config/dayJsConfigUTC";
import useStyles from "./useStyles";

const getTooltipText = (marker) => {
    if (!marker) return null

    const tooltipText = dayjsUTC(marker.timeStamp).format('DD.MM.YY, HH:mm:ss')

    return (
        <>
            <div>
                {tooltipText}
                {marker.timeZone && (<span>{` (${marker.timeZone})`}</span>)}
            </div>

            {marker.speed ? <div>{`скорость: ${marker.speed} км/ч`}</div> : null}
            {marker.gps_pointer ? <div>{`gps pointer: ${marker.gps_pointer}`} </div> : null}
        </>
    )
}

const MapObjRoutes = (props) => {
    const {
        activeRouteArr,
        isShowRouteTooltips
    } = props;

    const classes = useStyles()

    if (!activeRouteArr || !activeRouteArr.length) return null

    return (
        <>
            {activeRouteArr.length ? activeRouteArr.map(({route, color}, index) => {
                if (route?.length) {
                    return (
                        <Polyline key={index} pathOptions={{color}} positions={route.map(({x, y}) => [x, y])}>

                            {isShowRouteTooltips && (
                                route.map((marker, index) => (
                                    <CircleMarker
                                        key={index}
                                        center={[marker.x, marker.y]}
                                        pathOptions={{
                                            fillColor: 'none',
                                            opacity: .5
                                        }}
                                        radius={8}
                                        className={classes.tooltip}
                                    >
                                        <Tooltip
                                            key={`${marker.x}-${marker.y}`}
                                        >{getTooltipText(marker)}</Tooltip>
                                    </CircleMarker>
                                ))
                            )}
                        </Polyline>
                    )

                } else {
                    return null
                }
            }) : null}
        </>
    )
}

export default memo(MapObjRoutes)